import { SITE } from "../config/site";

/** Prominent fixed-fare lockup used beside the booking form and across the site. */
export default function FareLockup({ compact = false }) {
  return (
    <div
      data-testid="fare-lockup"
      className={`border border-[rgba(212,175,55,0.4)] bg-[#111111] ${compact ? "p-5" : "p-8"}`}
    >
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#A1A1AA]">
        Your fixed fare
      </p>
      <p className="mt-2 font-serif text-4xl font-bold text-[#D4AF37] sm:text-5xl">
        {SITE.fare}
      </p>
      <p className="mt-1 text-sm uppercase tracking-[0.15em] text-white">
        Essex ↔ London — either direction
      </p>
      <div className="gold-rule mt-5" />
      <p className="mt-5 text-sm leading-relaxed text-[#A1A1AA]">{SITE.paymentMessage}</p>
    </div>
  );
}
